import { Box } from "@mui/material";
import React from "react";

import { BinaryMetricsSection } from "components/common/BinaryMetricsSection";
import { ImageQueryPreview, PageContext } from "components/detector/ImageQueryPreview";
import { EXPLORE_PAGE_REFRESH_TIME } from "config/constants";
import { useGetMetrics } from "hooks/useGetMetrics/useGetMetrics";
import { useRefreshCount } from "hooks/useRefreshCount/useRefreshCount";
import { Typography } from "new-components/typography/Typography";
import { Detector } from "types/detectors";

export enum DisplayState {
  NO_PREDICTOR,
  NO_POSICHECKS,
  STATS,
}
export interface GraphEntry {
  name: string;
  val: number | Date;
}

export interface SimpleDemoStatsProps {
  isResetModalOpen: boolean;
  detector: Detector | undefined;
}

export const SimpleDemoStats = React.memo((props: SimpleDemoStatsProps) => {
  const { isResetModalOpen, detector } = props;

  const { count } = useRefreshCount(EXPLORE_PAGE_REFRESH_TIME, isResetModalOpen);
  const { histogramData, metrics } = useGetMetrics(detector?.id, EXPLORE_PAGE_REFRESH_TIME, count);

  return (
    <Box className="w-full">
      <>
        {histogramData.length > 0 && (
          <div className="border-b border-black border-solid mb-5 hidden md:block">
            <Typography variant="subtitle" textTransform="uppercase" className="text-gray-400">
              Stats
            </Typography>
          </div>
        )}
        <BinaryMetricsSection
          confidence={detector?.confidence_threshold || 0.75}
          metrics={metrics}
          pageContext={PageContext.Explore}
        />
        {detector && (
          <div className="mt-2 md:mt-6">
            <ImageQueryPreview detector={detector} count={count} pageContext={PageContext.Explore} />
          </div>
        )}
      </>
    </Box>
  );
});
